<template>
  <v-container>
    <v-progress-linear indeterminate :active="loading"></v-progress-linear>

    <div class="d-flex flex-row justify-center subtitle-1 flex-wrap ma-10"
      v-if="!addresses || addresses.length == 0" >
      Nenhum endereço cadastrado
    </div>

    <div class="d-flex flex-row flex-wrap mb-9" v-else>
      <div v-for="(address, i) in addresses" :key="`${address.id}-${i}`">
        <address-card v-model="addresses[i]" @removed="removed" />
      </div>
    </div>
  </v-container>
</template>

<script>
import bus from '@/plugins/eventBus';
import AddressCard from '@/components/addresses/AddressCard';

export default {
  data: () => ({
    addresses: [],
    loading: true,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.getAll();
  },
  methods: {
    getAll() {
      this.$store
        .dispatch('patientAddresses/get', this.user.id)
        .then((addresses) => {
          this.addresses = addresses;
        })
        .catch((err) => {
          bus.$emit('message', {
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removed(addressId) {
      this.addresses = this.addresses.filter(obj => obj.id !== addressId);
    },
  },
  components: {
    AddressCard,
  },
};
</script>
